import type { CreatorPlatform } from '../../shared/platforms';

/** WhatsApp and Telegram go live as soon as they're added, and ops verify the
 *  channel before payouts. Every other platform is reviewed first, and the
 *  code works there once it's approved. */
export const HAND_VERIFIED: ReadonlySet<CreatorPlatform> = new Set([
	'whatsapp',
	'telegram',
]);
